import React from 'react';
import { Box } from '@wix/design-system';
import { AppGeoAvailability } from './app-geo-availability';
import { AppCollections } from './app-collections';
import { AppLanguages } from './app-languages';
import { AppRequirements } from './app-requirements';
import type { MarketListing } from '../../../../services/market-listing';

export interface AppPropertiesProps {
  appId: string;
  appName: string;
  isWixApp: boolean;
  supportedLanguages: string[];
  isAppContentTranslatable: boolean;
  appDependencies: {
    id: string;
    slug: string;
    name: string;
  }[];
  appCollections: {
    slug: string;
    name: string;
  }[];
  geoAvailability: MarketListing['geoAvailability'];
}

export const AppProperties = ({
  appId,
  isWixApp,
  appName,
  supportedLanguages,
  isAppContentTranslatable,
  appDependencies,
  geoAvailability,
  appCollections,
}: AppPropertiesProps) => {
  return (
    <Box
      alignSelf="flex-start"
      border="1px solid #dcdcdc"
      borderRadius="8px"
      padding="18px 24px"
      width="272px"
      boxSizing="border-box"
      direction="vertical"
      gap="12px"
    >
      <AppGeoAvailability
        appId={appId}
        appName={appName}
        isWixApp={isWixApp}
        geoAvailability={geoAvailability}
      />
      {supportedLanguages.length > 0 && (
        <AppLanguages
          appId={appId}
          languages={supportedLanguages}
          isAppContentTranslatable={isAppContentTranslatable}
        />
      )}
      {appDependencies.length > 0 && (
        <AppRequirements appId={appId} appDependencies={appDependencies} />
      )}
      {appCollections.length > 0 && (
        <AppCollections appId={appId} collections={appCollections} />
      )}
    </Box>
  );
};
